import { InvestorPortal } from "../../types/InvestorPortal";
import "./VCPartnerContactInfoSubmissionForm.scss";

interface VCPartnerContactInfoSubmissionFormProps {
  investorPortal: InvestorPortal | null;
}

const VCPartnerContactInfoSubmissionForm: React.FC<
  VCPartnerContactInfoSubmissionFormProps
> = ({ investorPortal }) => {
  return (
    <div className="partner-submission-form">
      <div className="inner-todo">
        Contact info submission form for: {investorPortal?.name}
      </div>
    </div>
  );
};

export default VCPartnerContactInfoSubmissionForm;
